export default "__VITE_ASSET__DCVYQXFj__"